import React from 'react';

import { TicketIcon } from 'lucide-react';

import { cn } from '../../../utils/cn.js';

import { Skeleton } from '../../ui/skeleton.jsx';
import PortalSubHeading from './heading-sub.jsx';

export default function CardCoupon({ coupon, invoice, className, loading }) {
  return (
    <>
      {loading ? (
        <Skeleton className="h-[78px] w-full rounded-3xl border border-portal-foreground bg-portal-background" />
      ) : (
        <div
          className={cn(
            'relative flex flex-col items-start rounded-3xl border border-portal-foreground bg-portal-background text-portal-text',
            className,
          )}
        >
          <div className="flex flex-col px-4 py-4">
            {/* top */}
            <div className="flex w-full items-center gap-3">
              <TicketIcon className="size-5" />
              <PortalSubHeading className="text text-left text-xs xl:text-base">
                Nº {coupon.ROWID}
              </PortalSubHeading>
            </div>
            {/* bottom */}
            <div className="flex w-full items-center gap-3">
              <div className="w-5"></div>
              <div className="flex items-center gap-1">
                <span className="text-xs">Fatura {invoice.code}</span>
                {/* <ArrowUpRight className="size-3" /> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
